// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(min-width: 601px)";
var _4 = "form-3-xbA";
var _5 = "fields-O6M4S";
var _6 = "field-1Hz3C";
var _7 = "contacts-3SvRI";
var _8 = "header-1_l0P";
var _9 = "title-2P7NW";
var _a = "description-32ddh";
var _b = "controls-Zpcxw";
var _c = "submit-27gDw";
var _d = "cancel-25Mri";
var _e = "label-2NVV6";
var _f = "field__comment-27xxy";
var _10 = "form_withCancel-1pCAj";
export { _1 as "__esModule", _2 as "mobile", _3 as "exclude_mobile", _4 as "form", _5 as "fields", _6 as "field", _7 as "contacts", _8 as "header", _9 as "title", _a as "description", _b as "controls", _c as "submit", _d as "cancel", _e as "label", _f as "field__comment", _10 as "form_withCancel" }
export default { "__esModule": _1, "mobile": _2, "exclude_mobile": _3, "form": _4, "fields": _5, "field": _6, "contacts": _7, "header": _8, "title": _9, "description": _a, "controls": _b, "submit": _c, "cancel": _d, "label": _e, "field__comment": _f, "form_withCancel": _10 }
